<div class="summary">
	<p>
		O conceito do Bolão Pé na Cova é muito simples:<br/><br/>
		Você escolhe 15 celebridades que acha que vão {{metaphor}} no ano de {{year}}.<br/>
		No final do ano, quem fizer mais pontos ganha!
	</p>
	<p>
		Veja o <a (click)="nav.goRules()" class="link">regulamento completo</a>!
	</p>
	<p>{{signMessage}}</p>
	<app-block-350-300 />
</div>
